// Licht/donker en dichtheid: per apparaat bewaard. Thema volgt het systeem tenzij de gebruiker kiest.
export type ThemeChoice = "system" | "light" | "dark";
export type Density = "comfortable" | "compact";
const KEY = "bres:theme";
const DENSITY_KEY = "bres:density";

function read(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function write(key: string, value: string | null): void {
  try {
    if (value === null) localStorage.removeItem(key);
    else localStorage.setItem(key, value);
  } catch {
    // geen opslag
  }
}

export function readTheme(): ThemeChoice {
  const v = read(KEY);
  return v === "light" || v === "dark" ? v : "system";
}

export function applyTheme(choice: ThemeChoice): void {
  const root = document.documentElement;
  if (choice === "system") root.removeAttribute("data-theme");
  else root.setAttribute("data-theme", choice);
  write(KEY, choice === "system" ? null : choice);
  window.dispatchEvent(new CustomEvent("bres:theme", { detail: choice }));
}

export function effectiveTheme(): "light" | "dark" {
  const set = document.documentElement.getAttribute("data-theme");
  if (set === "light" || set === "dark") return set;
  return matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function readDensity(): Density {
  return read(DENSITY_KEY) === "compact" ? "compact" : "comfortable";
}

export function applyDensity(density: Density): void {
  const root = document.documentElement;
  if (density === "compact") root.setAttribute("data-density", "compact");
  else root.removeAttribute("data-density");
  write(DENSITY_KEY, density === "compact" ? "compact" : null);
}
